import type { OrderedSubMenuItem } from '@redturtle/qubicaamf-theme/components/Header/MegaMenu/MegaMenu';
import type {
  MenuItem,
  MenuConfiguration,
} from '@redturtle/qubicaamf-theme/types/dropdown-menu';
import {
  type TypedUseSelectorHook,
  useSelector,
  shallowEqual,
} from 'react-redux';

export type NavigationRootState = {
  navigation: {
    items: Array<MenuItem>;
  };
  dropdownMenuNavItems: {
    result: MenuConfiguration<OrderedSubMenuItem>[];
  };
};

const useNavigationMenuState = () => {
  const useTypedSelector: TypedUseSelectorHook<NavigationRootState> =
    useSelector<NavigationRootState>;
  const dropdownMenuNavItems = useTypedSelector(
    (state: NavigationRootState) => state.dropdownMenuNavItems?.result,
  );
  const navItems = useTypedSelector(
    (state: NavigationRootState) => state.navigation?.items,
    shallowEqual,
  );
  return { dropdownMenuNavItems, navItems };
};

export { useNavigationMenuState };
